import { NavLink, Outlet } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { useSession } from '../state/SessionContext';
import { api } from '../api/client';
import logo from '../assets/whr-logo.png';
import './AppLayout.css';

const navLinks = [
  { to: '/dashboard', label: 'Dashboard', exact: true },
  { to: '/my-card', label: 'My Card', exact: true },
  { to: '/raffle', label: 'Raffle', exact: true },
  { to: '/merchant', label: 'Merchant', exact: false },
];

const adminNavLinks = [
  { to: '/admin', label: 'Admin', exact: false },
];
const LOGOUT_REDIRECT_PATH = '/en/login' as const;

function AppLayout() {
  const { user, logout } = useSession();
  const [depositAddress, setDepositAddress] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (user) {
      api.getDepositAddress()
        .then((res) => setDepositAddress(res.address))
        .catch((err) => console.error('Failed to get deposit address:', err));
    }
  }, [user]);

  const handleLogout = useCallback(async (): Promise<void> => {
    await logout();
    window.location.assign(LOGOUT_REDIRECT_PATH);
  }, [logout]);

  const handleCopyAddress = useCallback(() => {
    if (depositAddress) {
      navigator.clipboard.writeText(depositAddress).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  }, [depositAddress]);

  // Показываем полный адрес
  const formatAddress = (addr: string) => addr;

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <div className="sidebar-header">
          <a href="/" className="sidebar-header-link">
            <img src={logo} alt="Plz Pay Me logo" className="sidebar-logo" />
            <span className="sidebar-title">Plz Pay Me</span>
          </a>
        </div>
        <nav className="sidebar-nav">
          {navLinks.map(link => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.exact}
              className={({ isActive }) =>
                isActive ? 'sidebar-link active' : 'sidebar-link'
              }
            >
              {link.label}
            </NavLink>
          ))}
          {user?.isAdmin && (
            <>
              <div className="sidebar-divider" />
              {adminNavLinks.map(link => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.exact}
                  className={({ isActive }) =>
                    isActive ? 'sidebar-link admin-link active' : 'sidebar-link admin-link'
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </>
          )}
        </nav>
        <button
          className="sidebar-logout"
          onClick={() => {
            void handleLogout();
          }}
        >
          Log out
        </button>
      </aside>
      <main className="app-main">
        <header className="app-header">
          <div>
            <h1 className="app-heading">Plz Pay Me</h1>
            <p className="app-subheading">Monitor orders and payments in real time.</p>
          </div>
          <div className="header-right">
            {depositAddress && (
              <div className="deposit-address-chip" onClick={handleCopyAddress} title="Click to copy">
                <span className="deposit-label">Your static address</span>
                <span className="deposit-address">{formatAddress(depositAddress)}</span>
                <span className="copy-icon">{copied ? '✓' : '📋'}</span>
              </div>
            )}
            {user && (
              <div className="user-chip">
                <span className="user-name">{user.username || `User ${user.telegramId}`}</span>
                <span className="user-id">#{user.telegramId}</span>
              </div>
            )}
          </div>
        </header>
        <section className="app-content">
          <Outlet />
        </section>
      </main>
    </div>
  );
}

export default AppLayout;
 
